import { NgModule } from "@angular/core"
import { PostBox } from "./post-box.component"
import { WriterAvatarModule } from "../writer-avatar/writer-avatar.module"
import { RedDotModule } from "../red-dot/red-dot.module"
import { CommonModule } from "@angular/common"
import { PostPreview } from "./post-preview/post-preview.component"
import { PostThirtyDayMessage } from "./post-thirty-day-message.component"
import { ModalModule } from "../modal/modal.module"
import { ViewHtmlModal } from "./modals/view-html-modal.component"
import { PostBoxFormsModule } from "./forms/post-box-forms.module"
import { PostActionButtons } from "./post-action-buttons/post-action-buttons.component"
import { RedeliverPostModal } from "./modals/redeliver-post-modal.component"
import { KeywordPhrase } from "./post-preview/keyword-phrase.component"
import { CollapseModule } from "ngx-bootstrap/collapse"
import { TooltipModule } from 'ngx-bootstrap/tooltip'
import { RouterModule } from "@angular/router"
import { RatingStarsModule } from "../rating-stars/rating-stars.module"
import { MaterialModule } from '../material/material.module'
import { PipesModule } from 'src/pipes/pipes.module'
import { PostDeclineReasonsModule } from '../post-decline-reasons/post-decline-reasons.module'
import { PopoverModule } from 'ngx-bootstrap/popover'

@NgModule({
  declarations: [
    PostBox,
    PostPreview,
    PostThirtyDayMessage,
    PostActionButtons,
    ViewHtmlModal,
    RedeliverPostModal,
    ViewHtmlModal,
    KeywordPhrase,
  ],
  imports: [
    WriterAvatarModule,
    CommonModule,
    ModalModule,
    PostBoxFormsModule,
    TooltipModule,
    RouterModule,
    CollapseModule.forRoot(),
    RatingStarsModule,
    MaterialModule,
    PipesModule,
    RedDotModule,
    PostDeclineReasonsModule,
    PopoverModule.forRoot(),
  ],
  exports: [
    PostBox
  ]
})
export class PostBoxModule { }
